import { render, staticRenderFns } from "./ListMessages.vue?vue&type=template&id=0be2dc01&lang=pug"
import script from "./ListMessages.vue?vue&type=script&lang=js"
export * from "./ListMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports